import Swiper from "swiper/bundle";
import "swiper/css/bundle";
const swiperBannerCards = new Swiper(".swiper-banner", {
  slidesPerView: 1,
  speed: 1000,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 20000,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
const swiperBanner = new Swiper(".swiper-banner-home", {
  slidesPerView: 1,
  speed: 1000,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 20000,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
    },
  },
});
const swiperWishlist = new Swiper(".swiper-wishlist", {
  slidesPerView: 1.6,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
const swiperReviews = new Swiper(".swiper-reviews", {
  spaceBetween: 10,
  loop: true,
  autoplay: true,
  breakpoints: {
    345: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 2,
    },
    1124: {
      slidesPerView: 3,
    },
    1440: {
      slidesPerView: 4,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
const swiperProductThird = new Swiper(".swiper-third", {
  spaceBetween: 10,
  loop: true,
  breakpoints: {
    345: {
      centeredSlides: true,
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 2,
    },
    1440: {
      centeredSlides: false,
      slidesPerView: 3,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
const swiperProductFour = new Swiper(".swiper-four-slide", {
  spaceBetween: 10,
  loop: true,
  breakpoints: {
    345: {
      centeredSlides: true,
      slidesPerView: 1.4,
    },
    640: {
      slidesPerView: 1.8,
    },
    768: {
      slidesPerView: 2.4,
    },
    1024: {
      centeredSlides: false,
      slidesPerView: 3,
    },
    1240: {
      centeredSlides: false,
      slidesPerView: 4,
    },
    1440: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
const swiperProductFive = new Swiper(".swiper-five-slide", {
  spaceBetween: 30,
  loop: true,
  breakpoints: {
    345: {
      centeredSlides: true,
      slidesPerView: 1.4,
    },
    640: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    1024: {
      centeredSlides: false,
      slidesPerView: 4,
    },
    1440: {
      slidesPerView: 5,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
const swiperCoollection = new Swiper(".swiper-collection-slide", {
  spaceBetween: 30,
  loop: true,
  breakpoints: {
    345: {
      slidesPerView: 3,
    },
    640: {
      slidesPerView: 5,
    },
    768: {
      slidesPerView: 7,
      centeredSlides: false,
    },
    1024: {
      centeredSlides: false,
      slidesPerView: 8,
    },
    1440: {
      slidesPerView: 9,
    },
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
const swiper = new Swiper(".mySwiper", {
  loop: true,
  spaceBetween: 10,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,
});
const swiper2 = new Swiper(".mySwiper2", {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});

const swiperAddiStepsTop = new Swiper(".swiper-addi-steps-top", {
  spaceBetween: 15,
  breakpoints: {
    345: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

const swiperAddiStepsBottom = new Swiper(".swiper-addi-steps-bottom", {
  spaceBetween: 15,
  breakpoints: {
    345: {
      slidesPerView: 1,
    },
    440: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1240: {
      slidesPerView: 4,
    },
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
